<template>
  <div class="index-container">
    <div style="
    position: fixed !important;
    width: 100%;
    height: 50px;
    z-index: 2048;
    pointer-events: none;"></div>
    <navbar v-if="!isBuilder" :show="true"></navbar>
    <sidebar v-show="show" :show="show" @done="vAppMain=true"></sidebar>
    <div class="bg-modal" style="position: fixed;"></div>
    <app-main v-if="vAppMain"></app-main>
    <!--<resize-observer @notify="handleResize" />-->
    <!--<footer-bar></footer-bar>-->

    <admin-modal></admin-modal>
    <lp-toast></lp-toast>
    <lp-progress-toast></lp-progress-toast>
  </div>
</template>

<script>
  import LpToast from './module/common/LpToast.vue'
  import Navbar from './layout/Navbar'
  import Sidebar from './layout/Sidebar'
  import AppMain from './layout/AppMain'
  import FooterBar from './layout/FooterBar'
  import AdminModal from "./module/admin/AdminModal";
  import LpProgressToast from "./module/common/LpProgressToast";

  export default {
    name: "Index",
    props: {
      type: String,
      required: true
    },
    components: {
      LpProgressToast,
      AdminModal,
      LpToast,
      Navbar,
      AppMain,
      FooterBar,
      Sidebar
    },
    computed: {
      isBuilder() {
        return this.$store.getters.fromBuilder;
      },
      serviceName() {
        return this.$store.getters.serviceName;
      }
    },
    async created() {
      try {
        let res = await this.$axios.get('admin/launchpack/service/info');
        this.$store.commit('setMasterServiceInfo', res.data);
        this.$root.$emit('menus');
      } catch {

      }

      if(window.innerWidth>768 && !this.show){
        this.$store.commit('setSideBar', true);
        this.$store.commit('setDevice', 'pc');
      }
      else {
        this.$store.commit('setSideBar', false);
        this.$store.commit('setDevice', 'mobile');
      }

      this.show = !!this.$store.getters.sidebar;

      $(window).resize(() => {
        if(window.innerWidth>768){
          this.$store.commit('setSideBar', true);
          this.$store.commit('setDevice', 'pc');
        }
        else{
          this.$store.commit('setSideBar', false);
          this.$store.commit('setDevice', 'mobile');
        }
      })
    },
    data () {
      return {
        show:false,
        vAppMain: false
      }
    },
    watch:{
      '$store.state.sidebar'(n){
        this.show = n;
      }
    },
    methods:{
      handleResize(){
        if(window.innerWidth>768){
          this.$store.commit('setSideBar', true);
          this.$store.commit('setDevice', 'pc');
        }
        else{
          this.$store.commit('setSideBar', false);
          this.$store.commit('setDevice', 'mobile');
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../node_modules/animate.css';

  .index-container {
    //font-family: 'Spoqa Han Sans';
    font-family: 'Noto Sans CJK KR';
  }

  .animated {
    animation-duration: .377s;
  }

  .title {
    font-weight: 400;
    font-size: 1.5rem;
  }

  //0.3
  //@import '~bulma';

  //@import '~wysiwyg.css/wysiwyg.sass';

  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome';

  body {
    background: #e9e9e9;
    height: 100%;
  }

  .nprogress-container {
    position: fixed !important;
    width: 100%;
    height: 50px;
    z-index: 2048;
    pointer-events: none;

    #nprogress {
      $color: #48e79a;

      .bar {
        background: $color;
      }
      .peg {
        box-shadow: 0 0 10px $color, 0 0 5px $color;
      }

      .spinner-icon {
        border-top-color: $color;
        border-left-color: $color;
      }
    }
  }
</style>
